import { render, staticRenderFns } from "./RegionFormDialog.vue?vue&type=template&id=5fdb675c&scoped=true"
import script from "./RegionFormDialog.vue?vue&type=script&lang=js"
export * from "./RegionFormDialog.vue?vue&type=script&lang=js"
import style0 from "./RegionFormDialog.vue?vue&type=style&index=0&id=5fdb675c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdb675c",
  null
  
)

export default component.exports